import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import InputSuffix from './InputSuffix';
import styles from '../SaleReportPage.module.scss';
import { buildBasicRows, buildBuildingRows, buildDetailRows } from '../fieldBuilders';

/* ── Icons ── */
const SidebarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 3v18M3 9h6M3 15h6" />
  </svg>
);

const HouseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M5 21V10l7-5 7 5v11" />
    <path d="M9 21v-6h6v6" />
  </svg>
);

function BasicBuildingSection({ config, sale, onChange }) {
  const fields = config.fields || {};

  const setField = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key]: val } });
  };

  const setVal = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key + '_edit']: val } });
  };

  if (!sale) return null;

  const basicRows = buildBasicRows(sale, config);
  const buildingRows = buildBuildingRows(sale, config);
  const detailRows = buildDetailRows(sale, config);

  return (
    <>
      {/* 기본정보 */}
      {basicRows.length > 0 && (
      <div className={styles.section}>
        <SectionHeader icon={<SidebarIcon />} title="기본정보" />
        <div className={styles.grid}>
          {basicRows.map(({ key, label, value, unit }) => (
            <Field
              key={key}
              label={label}
              span={3}
              toggle
              toggleEnabled={fields[`basic_${key}`]}
              onToggle={(v) => setField(`basic_${key}`, v)}
            >
              {unit ? (
                <InputSuffix
                  value={value === '-' ? '' : value}
                  unit={unit}
                  onChange={(v) => setVal(`basic_${key}`, v)}
                />
              ) : (
                <input
                  type="text"
                  value={value === '-' ? '' : value}
                  onChange={(e) => setVal(`basic_${key}`, e.target.value)}
                />
              )}
            </Field>
          ))}
        </div>
      </div>
      )}

      {/* 건물정보 */}
      {buildingRows.length > 0 && (
      <div className={styles.section}>
        <SectionHeader icon={<HouseIcon />} title="건물정보" />
        <div className={styles.grid}>
          {buildingRows.map(({ key, label, value, unit }) => (
            <Field
              key={key}
              label={label}
              span={3}
              toggle
              toggleEnabled={fields[`bldg_${key}`]}
              onToggle={(v) => setField(`bldg_${key}`, v)}
            >
              {unit ? (
                <InputSuffix
                  value={value === '-' ? '' : value}
                  unit={unit}
                  onChange={(v) => setVal(`bldg_${key}`, v)}
                />
              ) : (
                <input
                  type="text"
                  value={value === '-' ? '' : value}
                  onChange={(e) => setVal(`bldg_${key}`, e.target.value)}
                />
              )}
            </Field>
          ))}
        </div>
      </div>
      )}

      {/* 세부정보 (토지만) */}
      {detailRows.length > 0 && (
      <div className={styles.section}>
        <SectionHeader icon={<HouseIcon />} title="세부정보" />
        <div className={styles.grid}>
          {detailRows.map(({ key, label, value, unit }) => (
            <Field
              key={key}
              label={label}
              span={3}
              toggle
              toggleEnabled={fields[`detail_${key}`]}
              onToggle={(v) => setField(`detail_${key}`, v)}
            >
              {unit ? (
                <InputSuffix
                  value={value === '-' ? '' : value}
                  unit={unit}
                  onChange={(v) => setVal(`detail_${key}`, v)}
                />
              ) : (
                <input
                  type="text"
                  value={value === '-' ? '' : value}
                  onChange={(e) => setVal(`detail_${key}`, e.target.value)}
                />
              )}
            </Field>
          ))}
        </div>
      </div>
      )}
    </>
  );
}

export default BasicBuildingSection;
